import React, { useState } from 'react';
import { useStyle } from './PrequalStyle.js';
import Card from '@material-ui/core/Card';
import EirFixedBundleCardHeader from './EirFixedBundleCardHeader';
import EirFixedBundleCardFooter from './EirFixedBundleCardFooter';
import EirFixedBundleCardBody from './EirFixedBundleCardBody';
import { useWindowDimension } from './windowDimensions';

export default function EirFixedBundleCard(props) {
    const [state, setShadow] = useState({
        raised: false,
        shadow: 1,
    });
   
    const [width, height] = useWindowDimension();
    const classes = useStyle({
        themeColor: props.themeColor,
        themeColorOnHover: props.themeColorOnHover,
        themeColorForBroadbandCards: props.themeColorForBroadbandCards,
        themeColorForBroadbandCardsHover: props.themeColorForBroadbandCardsHover,
        useBroadbandCardColor: props.useBroadbandCardColor,
    });
    const headerImg = props.BundleData.attributes.filter(img => {
        return img.name === 'headerImg';
    });
    const moreInfo = props.BundleData.attributes.filter(info => {
        return info.name === 'moreInfo';
    });
    const moreInfoPopupMsg = props.BundleData.attributes.filter(msg => {
        return msg.name === 'moreInfoPopupMsg';
    });
    const standardFees = props.BundleData.standardFees.filter(fees => {
        return fees.feeType === 'ACTIVATION' || fees.feeType === 'INSTALLATION';
    });
    const startingPriceOfBundle = props.BundleData.priceBreakdown.map(price => {
        return price;
    });
    let imageUrl = '';
    if (headerImg.length > 0) {
        imageUrl = headerImg[0].value;
    }

    const getPriceIndex = bundleOffer => {
        try {
            let priceIndex = 0;
            // Generating subtitles for bundles cards
            var priceBreakdown = bundleOffer.priceBreakdown; 

            // Construct dymanic subtitles if required
            if (priceBreakdown.length > 1 ) {
                var onceOffFees = false;
                
                for (var i = 0; i < priceBreakdown.length; i++) {
                    var price = priceBreakdown[i];
                   
                    if (price.months === 1) {
                        // Continue the loop and come back with next iteration becasue we don't want to display 1st month additional costs
                        onceOffFees = true;
                        continue;
                    } else {
                        if (i === 0 || onceOffFees) {                            
                            priceIndex =i;
                            onceOffFees = false;
                        }
                    }
                }
            }
            return priceIndex;
        } catch (err) {
            return 0;
        }
    };
    const getSubtitles = bundleOffer => {
        try {
            
            var subtitles = bundleOffer.attributes
                .filter(attribute => attribute.name === 'strapline')
                .map(attribute => attribute.value);
                var priceBreakdown = bundleOffer.priceBreakdown;
            // Construct dymanic subtitles if required
            if (priceBreakdown.length > 1 || subtitles.length == 0) {
                const priceIndex = getPriceIndex(bundleOffer);
                subtitles = [];
                var price = priceBreakdown[priceIndex];
                subtitles.push(
                    'a month for ' + (price.months + price.startMonth) + ' Months'
                );              
            }
            return subtitles;
        } catch (err) {
            return [];
        }
    };
    const subtitleOfBundle = getSubtitles(props.BundleData);
    const priceIndex = getPriceIndex(props.BundleData);
    return (
        <div
            className={
                classes.BundleCard + ' ' + (props.totalCards == 1 ? classes.SingleCard : '')
            }>
            <Card
                className={state.raised ? classes.containerBundleCard : ''}
                onMouseOver={() => setShadow({ raised: true, shadow: 2 })}
                onMouseOut={() => setShadow({ raised: false, shadow: 1 })}
                raised={state.raised}>
                <EirFixedBundleCardHeader
                    headerImg={imageUrl}
                    contractLength={props.BundleData.contract.contractLength}
                    buttonState={(width > 611) ? state.raised :((props.index == props.currentSlide) ? true:state.raised )}
                    themeColor={props.themeColor}
                    themeColorOnHover={props.themeColorOnHover}
                    themeColorForBroadbandCards={props.themeColorForBroadbandCards}
                    themeColorForBroadbandCardsHover={props.themeColorForBroadbandCardsHover}
                    changeImageOnHover={props.changeImageOnHover}
                    useBroadbandCardColor={props.useBroadbandCardColor}
                />
                <EirFixedBundleCardBody
                    resources={props}
                    buttonState={(width > 611) ? state.raised :((props.index === props.currentSlide) ? true :state.raised )}
                    textButton={props.bundleButton}
                    themeColor={props.themeColor}
                    themeColorOnHover={props.themeColorOnHover}
                    themeColorForBroadbandCardsHover={props.themeColorForBroadbandCardsHover}
                    themeColorForBroadbandCards={props.themeColorForBroadbandCards}
                    useBroadbandCardColor={props.useBroadbandCardColor}
                    subtitleOfBundle={subtitleOfBundle}
                    priceIndex={priceIndex}                
                />    
                   
                {moreInfo.length > 0 && (
                    <EirFixedBundleCardFooter
                        moreInfo={moreInfo}
                        prices={startingPriceOfBundle}
                        moreInfoPopupMsg={moreInfoPopupMsg}
                        standardFees={standardFees}
                        contractLength={props.BundleData.contract.contractLength}
                        buttonState={(width > 611) ? state.raised :((props.index === props.currentSlide) ? true :state.raised )}
                        themeColor={props.themeColor}
                        themeColorOnHover={props.themeColorOnHover}
                        themeColorForBroadbandCards={props.themeColorForBroadbandCards}
                        themeColorForBroadbandCardsHover={props.themeColorForBroadbandCardsHover}
                        useBroadbandCardColor={props.useBroadbandCardColor}
                        priceIndex={priceIndex}
                        bundleData={props.BundleData}
                    />
                )}
            </Card>
        </div>
    );
}
